import React, { FC } from "react";
import { createStyles, makeStyles, Theme, useTheme } from "@material-ui/core/styles";
import { TimeCell } from "../../model/timeCell";
import { Grid, RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import { getTimeCellResourceById, NONE_ID } from "../../utils/calendarUtils";
import { concat } from "lodash";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      margin: 0,
      padding: 0,
      //            border: "1px solid lightgrey"
    },
    container: {
      maxHeight: 120,
    },
    hiddenButton: {
      visibility: "hidden",
      width: 1,
      height: 1,
    },
    resourceGrid: {
      margin: 0,
      padding: "0px 0px 0px 0px;",
      height: 14,
      fontSize: "small",
      visibility: "visible",
    },
    resourceRadio: {
      margin: 1,
      padding: 1,
      width: 24,
      height: 14,
      fontSize: "small",
      visibility: "visible",
      whiteSpace: "nowrap",
    },
    elipseText: {
      margin: 0,
      padding: 0,
      maxWidth: 90,
      height: 15,
      fontSize: "12px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    vScrollDiv: {
      margin: "4px, 4px",
      padding: "4px",
      width: "120px",
      maxHeight: "140px",
      overflowX: "auto",
      overflowY: "hidden",
    },
  })
);

export interface ResourceGroupProps {
  cell: TimeCell;
  maxDisplayRows: number;
  selectedId?: string;
  resourceGroupChanged: (cell: TimeCell) => void;
  tourType?: string;
}

const ResourceGroup: FC<ResourceGroupProps> = ({ cell, resourceGroupChanged, selectedId, maxDisplayRows, tourType }) => {
  const classes = useStyles(useTheme());
  const [selectedResourceId, setSelectedResourceId] = React.useState<string>(selectedId || NONE_ID);

  React.useEffect(() => {
    const newSelectedId = selectedId ? selectedId : NONE_ID;
    const newSelected = getTimeCellResourceById(cell, newSelectedId,tourType);
    if (newSelected) {
      cell.selectedId = newSelectedId;
      cell.selectedResource = newSelected;
    }
    setSelectedResourceId(cell.selectedId || NONE_ID);
  }, [cell, selectedId]);

  const handleClick = (event: any) => {
    const clickId = event.target.value;
    if (clickId) {
      if (clickId === selectedId) {
        // Clicking a selected resource clears it
        event.preventDefault();
        event.target.name = NONE_ID;
        event.target.value = NONE_ID;
        cell.selectedResource = undefined;
        cell.selectedId = NONE_ID;
      } else {
        const newSelected = getTimeCellResourceById(cell, clickId, tourType);
        cell.selectedId = clickId;
        cell.selectedResource = newSelected;
      }
      setSelectedResourceId(cell.selectedId || NONE_ID);
      resourceGroupChanged(cell);
    }
  };

  return (
    <Grid container className={classes.root} direction="column" justify="flex-start" alignItems="stretch" spacing={0}>
      <div className={classes.vScrollDiv}>
        <RadioGroup style={{ maxHeight: "110px" }} aria-label={cell.id} name={cell.id} value={selectedResourceId}>
          {cell &&
            cell.resources &&
            cell.resources.map((resource) => {
              if (resource.tourType === tourType){
                return (
                  <FormControlLabel
                    classes={{ label: classes.elipseText }}
                    key={resource.id}
                    value={resource.id}
                    control={<Radio size="small" style={{ padding: "0px 9px" }} />}
                    label={resource.name}
                    onClick={handleClick}
                  />
                );
                }
                else {
                  return null;
                }
            })}
          <FormControlLabel className={classes.hiddenButton} value={NONE_ID} control={<Radio size="small" />} label={NONE_ID} />
        </RadioGroup>
      </div>
    </Grid>
  );
};

export default ResourceGroup;
